import $api from 'http/index';
import { getOptions } from 'helpers/getOptions';
import { suppliesArchiveActions } from './suppliesArchiveSlice';

const PATHS = {
  materials: 'materials',
  manufacturers: 'manufacturers',
  inventory: 'inventory',
  glassBeads: 'glass-beads',
};

const url = (entity, id) =>
  `${process.env.REACT_APP_BASE_URL}/${PATHS[entity]}${id ? `/${id}` : ''}`;

// the register asks for these on the very same endpoints, so the archived lists have to match
const LIST_PARAMS = {
  materials: { skipDetails: false, populate: false },
  inventory: { populate: true },
};

const errorMessage = (error) => error?.response?.data?.message || error?.message || 'Request failed';

export const fetchArchived = (entity, filters) => async (dispatch) => {
  dispatch(suppliesArchiveActions.fetchStarted(entity));
  try {
    const { data } = await $api.get(url(entity), {
      ...getOptions(),
      params: { ...LIST_PARAMS[entity], ...filters, archived: true },
    });
    dispatch(suppliesArchiveActions.fetchSucceeded({ entity, data }));
    return data;
  } catch (error) {
    dispatch(suppliesArchiveActions.fetchFailed({ entity, error: errorMessage(error) }));
  }
};

// Resolve with the response so the dialog can both show the impact and refetch what it touched.
const request = (call) => async () => {
  try {
    const { data } = await call();
    return data;
  } catch (error) {
    throw new Error(errorMessage(error));
  }
};

export const fetchImpact = (entity, id, action) =>
  request(() => $api.get(`${url(entity, id)}/impact`, { ...getOptions(), params: { action } }));

export const archiveSupply = (entity, id) =>
  request(() => $api.patch(`${url(entity, id)}/archive`, {}, getOptions()));

export const restoreSupply = (entity, id) =>
  request(() => $api.patch(`${url(entity, id)}/restore`, {}, getOptions()));

export const purgeSupply = (entity, id) =>
  request(() => $api.delete(`${url(entity, id)}/purge`, getOptions()));
